import React, {useState, useEffect} from "react"
import data from "../../../../../data"

import {Warning} from "../../../../controls"

function CustomizeRegion({activity, regionCode, onChange}) {
  // state
  const [state, setState] = useState({
    availableAreas:[],
    soldoutRegions:[],
    regions:[]
  })
  //const [availableAreas, setAvailableAreas] = useState([])
  //const [soldoutRegions, setSoldoutRegions] = useState([])
  //const [items, setItems] = useState([])

  // 
  useEffect(() => {
    const availableAreas = data.Activity.getAvailableAreas(activity, regionCode)
    const soldoutRegions = activity.regionVariants
    .filter(rv => rv.isSoldOut)
    .map(rv => {
      let regionTitle = data.Regions.getTitle(rv.regionCode, 'de')
      return regionTitle
    })
    const regions = activity.regionVariants.filter(rv => !rv.isSoldOut)

    setState({availableAreas, soldoutRegions, regions})
  }, [activity, regionCode])

  // render
  const items = state.regions.map(rv => {
    return (
      <option value={rv.regionCode} key={rv.regionCode}>
        {data.Regions.getTitle(rv.regionCode, 'de')}
      </option>
    )
  })

  let soldoutWarning = null
  if(state.soldoutRegions.length > 0) {
    let s1 = items.length === 1 ? "der" : "den folgenden Regionen ausverkauft:"
    let s2 = items.length === 1 ? "ausverkauft" : ""
    soldoutWarning = (
      <Warning text={`Leider ist diese Aktivität in ${s1} ${state.soldoutRegions.join(', ')} ${s2}`}/>
    )
  }

  const availableAreasDiv = state.availableAreas ? <div className="customize-regions-areas">{state.availableAreas}</div> : null

  return (
    <div className="customize-regions">
      <h2>Region</h2>
      <select value={regionCode || ""} onChange={e => onChange(e.target.value)}>
        {items}
      </select>
      {availableAreasDiv}
      {soldoutWarning}
    </div>
  )
}

export default CustomizeRegion